import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Navbar.css";
import { useAuth } from "../../context/AuthContext";
import UniCircle from "../../assets/UniCircle2.png";
import { Home, Users, Bell, Panda, Search,  LogOut, X } from "lucide-react";

export default function Navbar() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchFocused, setIsSearchFocused] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      console.log("Searching for:", searchQuery);
    }
  };

  const clearSearch = () => {
    setSearchQuery("");
  };

  function NavIcon({ icon, text, to, notifications = 0, onClick }) {
    if (to) {
      return (
        <NavLink
          to={to}
          className={({ isActive }) =>
            `nav-icon ${isActive ? "active" : ""}`
          }
        >
          {icon}
          <span className="text">{text}</span>
          {notifications > 0 && (
            <span className="notification-badge">{notifications}</span>
          )}
        </NavLink>
      );
    }

  return (
    <div className="nav-icon" onClick={onClick}>
      {icon}
      <span className="text">{text}</span>
    </div>
  );
}

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <div className="logo">
          <img src={UniCircle} alt="Unicircle Logo" className="logo-image"/>
          <span className="logo-text">UniCircle</span>
        </div>
        <form className="search-container" onSubmit={handleSearch}>
          <Search className="search-icon" size={18} />
          <input 
            type="text"
            placeholder="Search for people, posts, or topics..."
            className={`search ${isSearchFocused ? 'focused' : ''}`}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onFocus={() => setIsSearchFocused(true)}
            onBlur={() => setIsSearchFocused(false)}
          />
          {searchQuery && (
            <button 
              type="button" 
              className="search-clear"
              onClick={clearSearch}
              aria-label="Clear search"
            >
              <X size={16} />
            </button>
          )}
        </form>
      </div>
      <div className="nav-icons">
        <NavIcon to="/home" icon={<Home size={20}/>} text="Home" />
        <NavIcon to="/network" icon={<Users size={20}/>} text="My Network"/>
        <NavIcon to="/notification" icon={<Bell size={20}/>} text="Notifications" notifications={5}/>
        <NavIcon to={`/profile/${user.userid}`} icon={<Panda size={20}/>} text="Profile"/>
        <NavIcon icon={<LogOut size={20}/>} text="LogOut" onClick={handleLogout} />
      </div>
    </nav>
  );
}